/** Shown by the (i) next to the BOQ Qty column on live task lists. */
export const BOQ_QTY_HELP = {
  title: 'BOQ Qty',
  body: 'How much BOQ work this task covers, in the BOQ unit — e.g. 450 sqft of brickwork on that floor. Filled only when the tasks were created with "Create tasks from BOQ"; a task no BOQ line matched shows "-". Open the task to see the measurement and the materials behind it. Reference only — it does not change dates or status.',
  example: 'BOQ "Brickwork 5 + 5 + 3" → 5 on Ground, 5 on First, 3 on Second floor task.'
};
